<template>
  <activtyList :orgType="orgType"/>
</template>
<script>
import ActivtyList from './ActivityList.vue';
export default {
  name:'institutionActivityList',
  data(){
    return{
      orgType:3,//1平台活动2学校活动3课程方活动
    }
  },
  components:{
    ActivtyList
  }
}
</script>